import React from 'react';

import Assets from '@app/assets';
import I18n from '@module/i18n';

const brands = () => (
  <div className="page-advertise page-advertise__brands">
    <h3>{I18n.t('page.advertise.brands')}</h3>
    <div className="page-advertise__brands-images">
      <img
        className="brand"
        src={Assets.lookup('gallery/brands/gstar.png')}
        width="141"
      />
      <img
        className="brand"
        src={Assets.lookup('gallery/brands/adobe.png')}
        width="38"
      />
      <img
        className="brand"
        src={Assets.lookup('gallery/brands/google.png')}
        width="100"
      />
      <img
        className="brand"
        src={Assets.lookup('gallery/brands/squarespace.png')}
        width="160"
      />
      <img
        className="brand"
        src={Assets.lookup('gallery/brands/samsung.png')}
        width="120"
      />
      <img
        className="brand"
        src={Assets.lookup('gallery/brands/shutterstock.png')}
        width="140"
      />
    </div>
  </div>
);

export default brands;
